import apiDashboard from '@/api/supplier/dashboard';

const defaultState = () => ({
	listSalesActivity: [],
	listSalesResume: [],
	listReturnActivity: [],
	listSalesProduct: [],
	listTopWarehouse: [],
	listScheduleWaiting: [],
	listScheduleToday: [],
	listScheduleTomorrow: [],
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSalesActivity(state, data) {
		state.listSalesActivity = data.data;
	},
	setSalesResume(state, data) {
		state.listSalesResume = data.data;
	},
	setReturnActivity(state, data) {
		state.listReturnActivity = data.data;
	},
	setSalesProduct(state, data) {
		state.listSalesProduct = data.data;
	},
	setTopWarehouse(state, data) {
		state.listTopWarehouse = data.data;
	},
	setScheduleWaiting(state, data) {
		state.listScheduleWaiting = data.data;
	},
	setScheduleToday(state, data) {
		state.listScheduleToday = data.data;
	},
	setScheduleTomorrow(state, data) {
		state.listScheduleTomorrow = data.data;
	},
};

const actions = {
	getSalesActivity({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getSalesActivity(params).then(({ data: { data } }) => {
				commit('setSalesActivity', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setSalesActivity', { data: [] });
			});
		});
	},
	getSalesResume({ commit }, params) {
		apiDashboard.getSalesResume(params).then(({ data: { data } }) => {
			commit('setSalesResume', { data: data.results });
		}).catch(() => {
			commit('setSalesResume', { data: [] });
		});
	},
	getReturnActivity({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getReturnActivity(params).then(({ data: { data } }) => {
				commit('setReturnActivity', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setReturnActivity', { data: [] });
			});
		});
	},
	getSalesProduct({ commit }, params) {
		apiDashboard.getSalesProduct(params).then(({ data: { data } }) => {
			commit('setSalesProduct', { data: data.results });
		}).catch(() => {
			commit('setSalesProduct', { data: [] });
		});
	},
	getTopWarehouse({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getTopWarehouse(params).then(({ data: { data } }) => {
				commit('setTopWarehouse', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setTopWarehouse', { data: [] });
			});
		});
	},
	getScheduleWaiting({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getScheduleWaiting(params).then(({ data: { data } }) => {
				commit('setScheduleWaiting', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setScheduleWaiting', { data: [] });
			});
		});
	},
	getScheduleToday({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getScheduleToday(params).then(({ data: { data } }) => {
				commit('setScheduleToday', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setScheduleToday', { data: [] });
			});
		});
	},
	getScheduleTomorrow({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getScheduleTomorrow(params).then(({ data: { data } }) => {
				commit('setScheduleTomorrow', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setScheduleTomorrow', { data: [] });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};